import { Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { IVerfuegbarkeitsstatus } from '../_interfaces/verfuegbarkeitsstatus';

import { VerfuegbarkeitsstatusService } from '../_services/verfuegbarkeitsstatus.service';

@Pipe({
  name: 'verfuegbarkeitsstatus'
})
export class VerfuegbarkeitsstatusPipe implements PipeTransform {
  constructor(
    private verfuegbarkeitsstatusService: VerfuegbarkeitsstatusService,
  ) { }

  transform(value: unknown, ...args: unknown[]): unknown { // args[0] muss gleich VU sein!
    //console.log("VerfuegbarkeitsstatusPipe.transform() value, args[0]: ", value, args[0]);
    if(value == null) return of('');

    return this.verfuegbarkeitsstatusService.getVerfuegbarkeitsstatusForVersorgungsunternehmen(args[0] as string)
    .pipe(
      map(response => {
        //console.log("VerfuegbarkeitsstatusPipe.transform(): response:", response);
        let search = value as string;
        let found = response.verfuegbarkeitsstatus.find(f => f.status == search);
        if(found != null) return found.bezeichnung;
        else return null;
      })
      , catchError(error => {
        console.error("VerfuegbarkeitsstatusPipe.transform()error: ", error);
        return of('');
      })
    );
  }

}
